export default __webpack_public_path__ + "static/media/news-inner-image.98ee49ae.jpg";